/*
 * Fills out missing values in breakpoints, always returns an object
 * `fillValues` flag defines whether missing values should be filled or not
 *
 * Example, fillValues = true: { xs: 8, md: 16, lg: 24 } -> { xs: 8, sm: 8, md: 16, lg: 24, xl: 24 }
 * Example, fillValues = true: [8, null, 16, 24] -> { xs: 8, sm: 8, md: 16, lg: 24, xl: 24 }
 * Example, fillValues = true: 8 -> { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }
 *
 * Example, fillValues = false: { xs: 8, md: 16, lg: 24 } -> { xs: 8, md: 16, lg: 24 }
 * Example, fillValues = false: [8, null, 16, 24] -> { xs: 8, md: 16, lg: 24 }
 * Example, fillValues = false: 8 -> { xs: 8 }
 */
import { sizes } from '../breakpoints';
import { applyForBreakpoints } from './media-apply';
export var spreadByBreakpoints = function spreadByBreakpoints(props, fillValues) {
  if (fillValues === void 0) {
    fillValues = false;
  }

  return (
    /* prettier-ignore */
    typeof props === 'object' && ('_' in props || 'xs' in props || 'sm' in props || 'md' in props || 'lg' in props || 'xl' in props || Object.keys(props).length === 0) ? applyForBreakpoints(props, sizes, fillValues) : Array.isArray(props) ? applyForBreakpoints(props, [0, 1, 2, 3, 4], fillValues) : fillValues ? {
      xs: props,
      sm: props,
      md: props,
      lg: props,
      xl: props
    } : {
      xs: props
    }
  );
};